import { Finyearmst, Txncategory } from "./tallyentry-api-model";

export class BookNumberReceiptResponse {

  public finyearmst: Finyearmst;
  public txncategory: Txncategory;
  public bookNo: number;
  public pavtiReceiptDetailsList: PavtiReceiptDetails[];

  constructor(init?: Partial<BookNumberReceiptResponse>) { 
    Object.assign(this, init);
  }

}


export class PavtiReceiptDetails {
  public receiptNo: number;
  public status: boolean;

  constructor(init?: Partial<PavtiReceiptDetails>) { 
    Object.assign(this, init);
  }
}

export class BookNoSearch {
  public finyearmstId: number;
  public txncategoryId: number;
  public bookNo: number;

  constructor(init?: Partial<BookNoSearch>) { 
    Object.assign(this, init);
  }
}